<template>
  <el-dialog
    :visible="visible"
    :close-on-click-modal="false"
    width="50%"
    top="5vh"
    class="add-contact-modal"
    @close="onClose"
  >
    <el-row slot="title">
      <h2>СОЗДАНИЕ КОНТАКТА</h2>
    </el-row>
    <el-form
      ref="addContactForm"
      :model="formData"
      :rules="rules"
      label-position="top"
    >
      <el-form-item prop="phone" label="Телефон:">
        <el-input v-model="formData.phone" :rows="5" />
      </el-form-item>
      <el-form-item prop="fio" label="ФИО:">
        <el-input v-model="formData.fio" :rows="5" />
      </el-form-item>
      <el-form-item prop="description" label="Описание:">
        <el-input v-model="formData.description" :rows="5" type="textarea" />
      </el-form-item>
      <el-row class="btn-block">
        <el-button type="primary" :loading="loading" @click="onSave">
          Сохранить
        </el-button>
      </el-row>
    </el-form>
  </el-dialog>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { UPDATE_CONTACT } from '@/store/actions/callCenter'
import { mapMutations } from 'vuex'

const CallCenter = RepositoryFactory.get('callCenter')

export default {
  name: 'AddContactModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: {
        phone: '',
        fio: '',
        description: '',
        status: '0',
      },
      rules: {
        phone: [
          {
            required: true,
            message: 'Введите номер телефона',
            trigger: 'blur',
          },
          {
            min: 11,
            message: 'Телефон заполнен не полностью',
            trigger: 'blur',
          },
        ],
      },
      loading: false,
    }
  },
  methods: {
    ...mapMutations({ updateContact: `callCenter/${UPDATE_CONTACT}` }),
    onSave() {
      this.$refs['addContactForm'].validate(valid => {
        if (valid) {
          this.loading = true
          CallCenter.postContact(this.formData)
            .then(res => {
              const { data, status } = res

              if (status === 201 && data) {
                this.updateContact(data)
                this.$message.success('Контакт успешно добавлен')
                this.onClose()
              }
            })
            .catch(err => this.errHandler(err))
            .finally(() => (this.loading = false))
        }
      })
    },
    onClose() {
      this.$emit('close')
      this.formData = {
        phone: '',
        fio: '',
        description: '',
        status: '0',
      }
    },
  },
}
</script>

<style lang="sass">
.add-contact-modal
  h2
    margin: 30px
    font-weight: bold
    font-size: 18px
    line-height: 17px
  .el-dialog__headerbtn
    top: 50px
    right: 50px
    font-size: 18px
  .el-dialog__body
    padding: 0 50px 50px
    .el-form-item__label
      font-size: 16px
      line-height: 17px
      color: #000
    .el-select
      width: 320px
    .el-input__inner, .el-textarea__inner, .el-button
      font-size: 16px
      font-family: Rubik, sans-serif
      font-weight: normal
    .btn-block
      margin-top: 50px
      button
        width: 200px
        height: 47px
  .cc-admin-loader
    width: 320px
</style>
